/*
 * @Author: OnismYY 2848335733@qq.com
 * @Date: 2023-12-08 14:55:34
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2025-11-17 15:36:53
 * @FilePath: \h5-front\src\utils\common-utils.js
 * @Description: 公共处理函数
 */

/**判断传入值【数组、对象、参数】是否为空，,返回true为空，false不为空 */
export function isEmpty(val) {
  if (typeof val == 'boolean') {
    return false
  }
  if (typeof val == 'number') {
    return false
  }
  if (val instanceof Array) {
    if (val.length == 0) return true
  } else if (val instanceof Object) {
    if (JSON.stringify(val) === '{}') return true
  } else {
    if (val == 'null' || val == null || val == 'undefined' || val == undefined || val == '') return true
    return false
  }
  return false
}

// 检查两个字符串集合是否相等，（值相同，顺序不同可判断）
export function isSetEqual(set1, set2) {
  if (set1.size !== set2.size) {
    return false
  }
  for (const item of set1) {
    if (!set2.has(item)) {
      return false
    }
  }
  return true
}

/**
 * @description:
 * @param {*} id  要查询的id值，可以是id||bisId||productId
 * @param {*} dataList  在哪个数组中查找id相同的对象
 * @return {*}  返回detaList中id与传入id相同的对象下的name，实现 id匹配name
 */
export const getNameById = (id, dataList) => {
  if (isEmpty(id) || dataList.length === 0) {
    return ''
  }
  let perObj = dataList.find((item) => item.id === id || item.bisId === id || item.productId === id)
  return perObj ? perObj.name : '未知'
}

/**
 * @description: 根据type(产品类型)，返回对应工作模式名称
 * @param {*} val   当前模式0,1,2,3，根据val的值返回模式的中文名
 * @param {*} type  drug表示打药系统，planting表示阳台种菜机
 * @return {*}
 */
export const getModeTitle = (val, type) => {
  const modeTitles = {
    // drug: {
    //   0: translate_i18n('common.idleMode'),//空闲模式
    //   1:translate_i18n('drugSystem.singleDrugMode'),//单次打药模式
    // },
    // planting: {
    //   0: translate_i18n('common.idleMode'),
    //   1: translate_i18n('plantSystem.singleWateringMode'),//单次浇水模式
    // },
    system: {
      0: "单次模式",
      1: "自动模式",
      2: "空闲",
    },
    fertilizerSet: {
      0: "自动配肥",
      1: "空闲",
    },
    acid: {
      0: "自动调酸",
      1: "空闲",
    },
    heating: {
      0: "手动模式",
      1: "自动模式",
    },
  };
  return (modeTitles[type] && modeTitles[type][val]) || null;
};

/**
 * 根据不同状态，返回不同文字及颜色
 */
export function judgeStatus(val, type) {
  const mappings = {
    color: {
      0: 'error',
      1: 'success',
      2: 'warning',
      3: 'grey'
    },
    text: {
      0: '已停止',
      1: '工作中',
      2: '故障',
      3: '休眠'
    }
  }
  if (!isEmpty(val) && mappings[type]) {
    return mappings[type][val] || '未知'
  }
}

// 用于格式化文件大小，将文件大小转换为可读性更好的字符串。
// 参数 size 是文件大小，返回格式化后的字符串。
// Format file size
export const formatFileSize = (size) => {
  const units = ['B', 'KB', 'MB', 'GB', 'TB']
  let unitIndex = 0

  while (size >= 1024 && unitIndex < units.length - 1) {
    size /= 1024
    unitIndex++
  }

  return `${size.toFixed(2)} ${units[unitIndex]}`
}

/**
 * 随机字符串, 只有字母,数字,下划线
 * @param {number} len 长度
 */
export function generateNonce(len = 24) {
  const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789_'
  let noceStr = '',
    maxPos = chars.length
  while (len--) noceStr += chars[(Math.random() * maxPos) | 0]
  return noceStr
}

/**
 * promise 简洁写法
   const {promise, resolve, reject} = new Deferred()

   return promise
 */
export class Deferred {
  constructor() {
    this.promise = new Promise((resolve, reject) => {
      this.resolve = resolve
      this.reject = reject
    })
  }
}

// 当index为js的偶数时，返回480，否则返回240
const getPhotoHeight = (index) => {
  let height = 0
  if (index % 3 === 0) {
    height = 480
  } else if (index % 3 === 1) {
    height = 240
  } else {
    height = 360
  }
  return height
}

// 将对象中的某些字段由String转为Number
// 使用方式 convertToNumber(editedItem.value, ['peopleNum', 'price', 'weight'])
//将editedItem.value中的'peopleNum', 'price', 'weight' 转为number
const convertToNumber = (obj, properties) => {
  properties.forEach((property) => {
    if (!isNaN(obj[property])) {
      obj[property] = +obj[property]
    } else {
      console.log('no isNaN')
    }
  })
}

/**
 * 将年月日或年月日时分秒格式的日期字符串转换为时间戳
 * @param {string} dateStr - 日期字符串，格式为 "YYYY-MM-DD" 或 "YYYY-MM-DD HH:mm:ss"
 * @returns {number|null} 返回时间戳（单位：毫秒），如果输入无效则返回 null
 */
export function dateToTimestamp(dateStr) {
  // 检查日期格式是否匹配 "YYYY-MM-DD" 或 "YYYY-MM-DD HH:mm:ss"
  const dateRegex = /^\d{4}-(0[1-9]|1[0-2])-(0[1-9]|[12]\d|3[01])$/
  const dateTimeRegex = /^\d{4}-(0[1-9]|1[0-2])-(0[1-9]|[12]\d|3[01])\s([01]\d|2[0-3]):([0-5]\d):([0-5]\d)$/

  if (!dateRegex.test(dateStr) && !dateTimeRegex.test(dateStr)) {
    console.error('日期格式无效：', dateStr)
    return null
  }

  // 尝试解析日期字符串
  const parsedDate = new Date(dateStr.replace(' ', 'T'))

  // 检查解析是否成功
  if (isNaN(parsedDate.getTime())) {
    console.error('日期解析失败：', dateStr)
    return null
  }

  return parsedDate.getTime()
}

/**
 * 转换时间格式
 * @param {*} dates [ "2024-11-06", "2024-11-07" ]
 * @returns [ "2024-11-05T16:00:00.000Z", "2024-11-07T15:59:59.999Z" ]
 */
export function convertDates(dates) {
  if (dates.length < 2) {
    return []
  }

  // 将起始日期减去 8 小时
  const startDate = new Date(dates[0])
  startDate.setHours(16, 0, 0, 0) // 设置时间为16:00:00.000

  // 将结束日期加到当天的最后一毫秒
  const endDate = new Date(dates[1])
  endDate.setHours(15, 59, 59, 999) // 设置时间为15:59:59.999

  // 将日期转为 ISO 字符串
  const startIso = startDate.toISOString()
  const endIso = endDate.toISOString()

  return [startIso, endIso]
}

/**
 * 获取时间范围的第一个和最后一个时间戳
 * @param {Array} dates - 日期字符串数组
 * @returns {Object} 包含 firstTimestamp 和 lastTimestamp 的对象
 */
// export function getFirstAndLastTimestamp(dates) {
//   let firstTimestamp = null
//   let lastTimestamp = null

//   if (dates && dates.length > 0) {
//     // 将日期字符串转换为时间戳，并找到最早和最晚的时间戳
//     const timestamps = dates.map((date) => new Date(date).getTime()).sort((a, b) => a - b)
//     firstTimestamp = timestamps[0] // 最早的时间戳
//     lastTimestamp = timestamps[timestamps.length - 1] // 最晚的时间戳
//   } else {
//     // 默认使用昨天到今天的时间范围
//     const now = new Date()
//     const today = new Date(now.getFullYear(), now.getMonth(), now.getDate())
//     const yesterday = new Date(today)
//     yesterday.setDate(today.getDate() - 1)

//     firstTimestamp = yesterday.getTime()
//     lastTimestamp = today.getTime()
//   }

//   return { firstTimestamp, lastTimestamp }
// }
/**
 * 获取时间范围的第一个和最后一个时间戳
 * @param {Array} dates - 日期字符串数组
 * @returns {Object} 包含 firstTimestamp 和 lastTimestamp 的对象
 */
export function getFirstAndLastTimestamp(dates, useDefault = false) {
  let firstTimestamp = null;
  let lastTimestamp = null;

  // 辅助函数：转为北京时间当天起止
  const startOfDayInBeijing = (date) => {
    const d = new Date(date);
    const utc = d.getTime() + d.getTimezoneOffset() * 60000; // 转为 UTC
    const beijing = utc + 8 * 60 * 60 * 1000; // UTC +8
    const localStart = new Date(beijing);
    localStart.setUTCHours(0, 0, 0, 0); // 北京时间的 00:00:00
    return localStart.getTime() - 8 * 60 * 60 * 1000; // 转回时间戳（毫秒）
  };

  const endOfDayInBeijing = (date) => {
    const d = new Date(date);
    const utc = d.getTime() + d.getTimezoneOffset() * 60000;
    const beijing = utc + 8 * 60 * 60 * 1000;
    const localEnd = new Date(beijing);
    localEnd.setUTCHours(23, 59, 59, 999);
    return localEnd.getTime() - 8 * 60 * 60 * 1000;
  };

  if (dates && dates.length > 0) {
    const sortedDates = dates.sort((a, b) => new Date(a) - new Date(b));
    firstTimestamp = startOfDayInBeijing(sortedDates[0]);
    lastTimestamp = endOfDayInBeijing(sortedDates[sortedDates.length - 1]);
  } else if (useDefault) {
    // 默认使用昨天到今天（北京时间）
    const now = new Date();
    const today = startOfDayInBeijing(now);
    const yesterday = today - 24 * 60 * 60 * 1000;

    firstTimestamp = yesterday;
    lastTimestamp = endOfDayInBeijing(now);
  }

  return { firstTimestamp, lastTimestamp };
}



/**
 * 格式化时间戳为 "YYYY-MM-DD" 格式，不带时分秒
 * @param {number} timestamp - 时间戳
 * @returns {string} 格式化后的日期字符串
 */
export function formatDate(timestamp) {
  const date = new Date(timestamp)
  const year = date.getFullYear()
  const month = String(date.getMonth() + 1).padStart(2, '0')
  const day = String(date.getDate()).padStart(2, '0')
  return `${year}-${month}-${day}`
}

//
/**
 * 格式化时间戳为 "YYYY-MM-DD HH:mm:ss" 格式，带时分秒
 * @param {number} timestamp - 时间戳
 * @returns {string} 格式化后的日期时间字符串
 */
export const formatDateT = (timestamp) => {
  const date = new Date(timestamp)
  return `${date.getFullYear()}-${(date.getMonth() + 1).toString().padStart(2, '0')}-${date
    .getDate()
    .toString()
    .padStart(2, '0')} ${date.getHours().toString().padStart(2, '0')}:${date
    .getMinutes()
    .toString()
    .padStart(2, '0')}:${date.getSeconds().toString().padStart(2, '0')}`
}

/**
 * @description: 根据deviceType返回对应中文名
 * @return {*}
 */
const deviceNames = {
  pump: '水泵',
  sensor: '传感器',
  valve: '进口阀',
  btValve: '蝶阀',
  tank: '水池',
  flowmeter: '流量计',
  irrValve: '电磁阀',
  branchValve: '支管电磁阀',

  //
  flowmeter: '流量计',
  fan: '风机',
  roller: '卷膜机',
  light: '补光灯',

  // 水肥中心
  ecphSensor: 'EC&pH监测',
  dosingFerValve: '吸肥电磁阀',
  dosingPHValve: '吸酸电磁阀',
  dosingPump: '吸肥泵',
  mixPump: '搅拌泵'
}
export const getDeviceName = (deviceType) => {
  if (isEmpty(deviceType)) return '未知'
  return deviceNames[deviceType] || deviceType
}

/**
 * @description: 根据startupType(启动类型)返回对应中文名
 * @param {*} val
 * @return {*}
 */
export const getStartupTypeTitle = (val) =>
  ({
    FRQ: '变频器启动',
    DO: 'DO直启'
  }[val] || '')

/**
 * @description: 根据控制类型，返回控制名称
 * @return {*}
 */
const controlNames = {
  drug: '打药',
  environment: '环控中心',
  fertilizer: '水肥系统',
  atomizing: '自动'
}
export const getContainerName = (containerType) => {
  if (isEmpty(containerType)) return '未知'
  return controlNames[containerType] || containerType
}

/**
 * @description: 根据控制类型，返回控制名称
 * @return {*}
 */
const weekNames = {
  1: '星期一',
  2: '星期二',
  3: '星期三',
  4: '星期四',
  5: '星期五',
  6: '星期六',
  7: '星期天'
}
export const getWeeksrName = (containerType) => {
  if (isEmpty(containerType)) return '未知'
  return weekNames[containerType] || containerType
}
/**
 * @description: 返回报警等级及对应颜色
 * @param {number|string} containerType - 报警等级
 * @return {object} 返回对象包含 `name` 和 `color`
 *   color: getAlarmNames(item.level).color
 *   {{ getAlarmNames(item.level).name }}
 */
const alarmNames = {
  1: '警告',
  2: '错误',
  3: '严重错误',
}

const alarmColors = {
  0: '#4CAF50', // 一般 - 绿色
  1: '#FFC107', // 一般 - 绿色
  2: '#ffa600ff', // 紧急 - 黄色
  3: '#F44336', // 严重 - 红色
}

export const getAlarmNames = (containerType) => {
  if (!containerType || typeof containerType === 'undefined') {
    return { name: '未知', color: '#9E9E9E' } // 默认灰色表示未知
  }
  const name = alarmNames[containerType] || containerType
  const color = alarmColors[containerType] || '#9E9E9E' // 默认灰色
  return { name, color }
}

/**
 * 校验ipv4地址
 * @param {*} ip 
 * @returns 
 * IPv4 格式要求：
    4 段十进制数字，由英文小数点 . 分隔。
    每段数字必须在范围 [0, 255] 内。
    不能有前导零（例如 01 不合法）。
    每段必须是数字，不能包含非数字字符。
    总体格式：XXX.XXX.XXX.XXX。
 */
    export function isValidIpv4(ip) {
      // 按英文小数点切割
      const parts = ip.split(".");
    
      // 必须正好分成 4 段
      if (parts.length !== 4) {
        return false;
      }
    
      // 检查每段是否为 0 到 255 的数字
      return parts.every((part) => {
        // 检查是否为数字，且无前导零（单独的 '0' 是合法的）
        if (!/^\d+$/.test(part) || (part.length > 1 && part.startsWith("0"))) {
          return false;
        }
    
        const num = parseInt(part, 10);
        return num >= 0 && num <= 255;
      });
    }



/**
 * 计算展开更多中 describe-list 需要展示的字段
 * @param {Object} item - 当前展开的那条数据
 * @param {Array} headers - 表格头部定义的 headers（[{key: 'xxx'}]）
 * @param {Array} excludeFields - 手动排除的字段
 * @returns {Array} - 需要展示的字段数组
 * item,是表格所有内容，headers是表格当前显示内容，extraExcludeFields是额外需要排除的字段，剩下的就是展开需要显示的字段
 */
export function getFieldsToShow(item, headers = [], excludeFields = []) {
  if (!item || typeof item !== 'object') return []

  // 1. headers 已经显示的字段 key
  const headerKeys = headers.map((h) => h.key)

  // 2. item 的所有一级字段
  const itemKeys = Object.keys(item)

  // 3. 合并排除字段
  const excludeSet = new Set([...headerKeys, ...excludeFields])

  // 4. 过滤掉不需要展示的字段
  const result = itemKeys.filter((key) => !excludeSet.has(key))

  return result
}


    /**
 * 清理对象中为 null / undefined / '' 的字段，
 * 但允许指定部分字段不清理。
 * 
 * @param {Object} obj - 原始对象
 * @param {Object} [options] - 可选配置
 * @param {boolean} [options.removeEmptyString=true] - 是否去除空字符串
 * @param {string[]} [options.excludeKeys=[]] - 保留字段名数组（即使值为 null/undefined 也不删除）
 * @returns {Object} - 清理后的新对象
 * 
 *   //使用方式 ✨ 清理时保留 sn 字段（即使为空）
  para = cleanObject(para, { excludeKeys: ['sn'] })
 */
export const cleanObject = (obj, { removeEmptyString = true, excludeKeys = [] } = {}) =>
  Object.fromEntries(
    Object.entries(obj).filter(([k, v]) =>
      excludeKeys.includes(k)
        ? true
        : v !== null && v !== undefined && (!removeEmptyString || v !== '')
    )
  )

/**********
 * 传入整个对象，返回设备是否在线（true/false）
 * 优先判断对象中是否存在isOnline对象，存在则直接返回
 * 若不存在，优先使用item.attribete.t，不存在则使用item.updatedAt（依据此时间距离现在是否超过24小时判断）
  item: { attribute, updatedAt, isOnline? }
  // 未来的时间也是显示在线
 * 
 *  ***************/

export function checkOnline(item) {
  if (!item) return false

  const now = Date.now()

  // ① 如果 item 中已有 isOnline → 优先使用
  if ("isOnline" in item) {
    return Boolean(item.isOnline)
  } else {
    // console.warn(`【checkOnline】item ${item?.sn || item?.id} 未提供 isOnline 字段，将自动判定`)
  }

  // ② 优先使用 attribute.t
  let timeVal = item?.attribute?.t ?? item?.updatedAt

  if (!timeVal) {
    // console.warn(`【checkOnline】item ${item?.sn || item?.id} 缺少时间（t / updatedAt），默认为离线`)
    return false
  }

  // 兼容时间戳或字符串
  let ts = Number(timeVal)
  if (isNaN(ts)) ts = new Date(timeVal).getTime()

  if (!ts || isNaN(ts)) {
    // console.warn(
    //   `【checkOnline】item ${item?.sn || item?.id} 时间格式无效：${timeVal}，默认为离线`
    // )
    return false
  }

  // ③ 超过 24h 视为离线
  const diffH = (now - ts) / (1000 * 60 * 60)
  if (diffH > 24) {
    // console.warn(
    //   `【checkOnline】item ${item?.sn || item?.id} 超过 24 小时未更新(${diffH.toFixed(
    //     1
    //   )}h)，判定为离线`
    // )
    return false
  }

  // 正常在线
  return true
}

/************************************************ */
    
